export const GOVERNMENT_AGENCY = 1
export const INSTITUTION = 2
